import React, { useCallback, useRef } from "react";
import { Button, Tooltip } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

// Local upload control rather than GridToolbar's built-in `showUpload`
// button: core's toolbar input reads `event.target.files[0]`, so it can only
// ever hand back one workbook. A RelVal week arrives as several source
// workbooks (SP spread time series, CLO Factbook, Wells RMBS, Corporate
// Spreads), so this input carries `multiple` and hands the caller the whole
// array. Styling mirrors core's BUTTON_STYLES.upload so the toolbar still
// reads as one row of buttons.
const UPLOAD_BUTTON_SX = {
  backgroundColor: "lightblue",
  color: "black",
  "&:hover": { backgroundColor: "rgba(173, 216, 230, 0.8)" },
};

export const SOURCE_FILE_INPUT_TEST_ID = "relval-source-file-input";

const SourceFileUploadButton = ({
  label = "Import Source Files",
  tooltip = "",
  acceptedFileTypes = ".xlsx,.xls",
  disabled = false,
  onUpload,
}) => {
  const inputRef = useRef(null);

  const handleClick = useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleChange = useCallback(
    (event) => {
      const files = Array.from(event.target.files || []);
      // Reset the input before dispatching so re-selecting the same
      // workbooks fires another change event (a failed import is normally
      // retried with the identical file set).
      event.target.value = "";
      if (files.length) onUpload?.(files);
    },
    [onUpload],
  );

  return (
    <>
      <Tooltip title={tooltip}>
        <span>
          <Button
            sx={UPLOAD_BUTTON_SX}
            startIcon={<UploadIcon />}
            onClick={handleClick}
            disabled={disabled}
          >
            {label}
          </Button>
        </span>
      </Tooltip>
      <input
        type="file"
        multiple
        ref={inputRef}
        style={{ display: "none" }}
        accept={acceptedFileTypes}
        onChange={handleChange}
        data-testid={SOURCE_FILE_INPUT_TEST_ID}
      />
    </>
  );
};

export default SourceFileUploadButton;
